<template>
  <div class="text-center">
    <img :src="imageUrl('locashop-loading.gif')" alt="Carregando...">
  </div>
</template>

<script>
  import * as config from '../../config'

  export default{
    name: 'Loading',
    computed: {
      apiDomain () {
        return config.apiDomain
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Loading.vue?71e6243e